module.exports = __webpack_public_path__ + "img/7passenger_stopped.54249f19.svg";